(function () {
  function initDroneFaqs() {
    const page = document.querySelector('.cs-drone-faqs-page, .cs-nano-faqs-page');
    if (!page || !window.jQuery) return;
    const $ = window.jQuery;

    $('.FAQsRight .Section span', page).each(function () {
      $(this).next('.panel-content').hide();
    });

    $('.FAQsRight .Section span', page).on('click', function () {
      $('.FAQsRight .Section span', page).removeClass('iconTransform');
      $(this)
        .parent()
        .find('.panel-content')
        .slideToggle(function () {
          if ($(this).parent().find('.panel-content').is(':visible')) {
            $(this).parent().find('span').addClass('iconTransform');
            $(this).parent().siblings().find('.panel-content').slideUp();
          } else {
            $(this).parent().find('span').removeClass('iconTransform');
          }
        });
    });

    $('.FAQsLeft ul li', page).on('click', function () {
      const faqIndex = $(this).index() + 1;
      $('html, body').animate(
        {
          scrollTop: $('.FAQsRight .panel:nth-child(' + faqIndex + ')', page).offset().top - 1,
        },
        800
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDroneFaqs);
  } else {
    initDroneFaqs();
  }
})();
